import { AUTH_API_URL, authBaseAPI } from 'api/APIBase';

/** Gets FMH token using Auth0 access token */
export async function getFmhToken({ accessToken }: { accessToken: string }) {
    const url = `${AUTH_API_URL}/access_tokens/`;
    return authBaseAPI.base.auth(`Bearer ${accessToken}`).url(url).get().json<{
        access_token: string;
        permissions: string[];
        restricted_access: boolean;
        npi?: string;
        segment_ids: string[];
    }>();
}
